import {getCurrentYear} from '../../utils/commons'
import TechGearInsiderLogo from './logo'
import {techGearInsiderStylesIN, techGearInsiderStylesUS} from './styles'

const baseConfig = {
  domainName: 'techgearinsider' as const,
  domainType: 'insider' as const,
  siteName: 'Tech Gear Insider',
  favicon: '/favicons/techgearinsider.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-6SZ7DF87CZ',
    camelCaseUrl: 'TechGearInsider.com',
    logo: <TechGearInsiderLogo className="size-14 shrink-0 tablet:size-11" />,
    title: (category: string, _count: string) =>
      `${category} Worth Buying in ${getCurrentYear()} — Our Top Picks | TechGearInsider.com`,
    description: (_category?: string, _count?: string) =>
      `TechGearInsider.com evaluates top electronics products using in-depth analysis and verified user feedback. Discover recommended options you'll value this year.`,
    styles: techGearInsiderStylesUS,
  },
  in: {
    measurementId: 'G-7VZEEH0D8X',
    camelCaseUrl: 'TechGearInsider.in',
    logo: <TechGearInsiderLogo className="size-14 shrink-0 tablet:size-11" locale="in" />,
    title: (category: string, _count: string) =>
      `${category} Worth Buying in ${getCurrentYear()} — Our Top Picks | TechGearInsider.in`,
    description: (_category?: string, _count?: string) =>
      `TechGearInsider.in evaluates top electronics products using in-depth analysis and verified user feedback. Discover recommended options you'll value this year.`,
    styles: techGearInsiderStylesIN,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
